// import styles
import '@scss/main.scss';
import '@lib/scss/base.lib.scss';
// require main js file
require('@js/index');

require('@js/swiper');
require('@js/ajax-blog');
require('@js/ajax-team');
require('@js/ajax-press');
require('@js/cursor.js');
require('@js/anchors-cards-image');
require('@js/accordions');
require('@js/toc');
require('@js/img-slider-wtabs');
require('@js/select');